"use strict";
import { useCallback } from "react";
import { useCurrentLocale } from "uniswap/src/features/language/hooks";
export function useHeaderDateFormatter() {
  const locale = useCurrentLocale();
  return useCallback(
    (time) => {
      if (!time) {
        return "-";
      }
      const headerTimeFormatOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
      };
      return new Date(time * 1e3).toLocaleString(locale, headerTimeFormatOptions);
    },
    [locale]
  );
}
